import React from "react";

const AboutLanding = () => {
  return (
    <div className="about_landing">
      <p className="about display-flex width-height">About Us</p>
    </div>
  );
};

export default AboutLanding;
